import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const DataGrantCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/DataGrant/DataGrantCreateUpdatePage")),
);
const DataGrantViewPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/DataGrant/DataGrantViewPage")),
);
const DataGrantsPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/DataGrant/DataGrantsPage")),
);
const TenantConnectionViewPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/TenantConnection/TenantConnectionViewPage")),
);
const TenantConnectionUpdatePage = Loadable(
  lazy(
    () => import("../../MainAppView/TenantToTenant/TenantConnection/TenantConnectionUpdatePage"),
  ),
);
const TenantConnectionsPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/TenantConnection/TenantConnectionsPage")),
);
const TenantConnectionIndexPage = Loadable(
  lazy(
    () =>
      import("../../MainAppView/TenantToTenant/TenantConnectionIndex/TenantConnectionIndexPage"),
  ),
);
const TenantConnectionRequestCreateUpdatePage = Loadable(
  lazy(
    () =>
      import("../../MainAppView/TenantToTenant/TenantConnectionRequest/TenantConnectionRequestCreateUpdatePage"),
  ),
);
const TenantConnectionRequestViewPage = Loadable(
  lazy(
    () =>
      import("../../MainAppView/TenantToTenant/TenantConnectionRequest/TenantConnectionRequestViewPage"),
  ),
);
const TenantConnectionRequestsPage = Loadable(
  lazy(
    () =>
      import("../../MainAppView/TenantToTenant/TenantConnectionRequest/TenantConnectionRequestsPage"),
  ),
);
const TenantRequestCreateUpdatePage = Loadable(
  lazy(
    () => import("../../MainAppView/TenantToTenant/TenantRequest/TenantRequestCreateUpdatePage"),
  ),
);
const TenantRequestViewPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/TenantRequest/TenantRequestViewPage")),
);
const TenantRequestsPage = Loadable(
  lazy(() => import("../../MainAppView/TenantToTenant/TenantRequest/TenantRequestsPage")),
);

export function TenantToTenantRoutes() {
  return (
    <>
      {/* TenantConnection index page */}
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTIONS_INDEX)}
        render={() => <TenantConnectionIndexPage />}
      />

      {/* TenantConnectionRequest */}
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTION_REQUESTS)}
        render={() => <TenantConnectionRequestsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTION_REQUEST_VIEW())}
        render={() => <TenantConnectionRequestViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTION_REQUEST_CREATE)}
        render={() => <TenantConnectionRequestCreateUpdatePage />}
      />

      {/* TenantConnection */}
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTIONS)}
        render={() => <TenantConnectionsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTION_VIEW())}
        render={() => <TenantConnectionViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantConnectionManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_CONNECTION_EDIT())}
        render={() => <TenantConnectionUpdatePage />}
      />

      {/* TenantRequest */}
      <AuthorizedRoute
        permissions={[AppPermission.TenantRequestRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_REQUESTS)}
        render={() => <TenantRequestsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantRequestRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_REQUEST_VIEW())}
        render={() => <TenantRequestViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantRequestManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_REQUEST_CREATE)}
        render={() => <TenantRequestCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.TenantRequestManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.TENANT_REQUEST_EDIT())}
        render={() => <TenantRequestCreateUpdatePage />}
      />

      {/* DataGrant */}
      <AuthorizedRoute
        permissions={[AppPermission.DataGrantRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.DATA_GRANTS())}
        render={() => <DataGrantsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.DataGrantRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.DATA_GRANT_VIEW())}
        render={() => <DataGrantViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.DataGrantManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.DATA_GRANT_CREATE())}
        render={() => <DataGrantCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.DataGrantManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.DATA_GRANT_EDIT())}
        render={() => <DataGrantCreateUpdatePage />}
      />
    </>
  );
}
